import React, { useState } from "react";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import authService from "../../api/auth/authService";
import AuthShell from "./AuthShell";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [errorVal, setError] = useState<string>("");

  const handleFormSubmit = async (data: any) => {
    console.log("handelSubmit", data);
    setError("");
    setLoading(true);
    try {
      const resData = await authService.reSetPassword(data);
      if (resData.status) {
        setTimeout(() => {
          navigate("/success", {
            state: {
              title: "Password Reset Instructions Sent.",
              titleColor: "",
              description:
                "Check your email for instructions to reset your password. If you don't receive it soon, please check your spam folder or contact support.",
              descriptionColor: "",
            },
          });
        }, 1000);
        setLoading(false);
      } else {
        setError(data.message);
      }
    } catch (err: any) {
      console.log("Login failed:", err.message);
      setError(err.message);
      setLoading(false);
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  return (
    <AuthShell
      title="Reset-Password"
      heading="Reset password"
      subheading="Tell us the email on your account and we'll send instructions to reset your password."
      footNote={<Link to={`/`}>Return to login</Link>}
      brandHeadline="Back to work in a couple of minutes."
      brandSubcopy="Your projects, schedules and daily progress are exactly where you left them."
    >
      {errorVal && (
        <div className="pxauth__alert" role="alert">
          <ExclamationCircleFilled className="pxauth__alertIcon" aria-hidden="true" />
          <span className="pxauth__alertText">{errorVal}</span>
        </div>
      )}

      <form
        className="pxauth-form"
        noValidate
        onSubmit={handleSubmit(handleFormSubmit)}
      >
        <div className="pxauth-field">
          <div className="pxauth-labelRow">
            <label className="pxauth-label" htmlFor="pxauth-email">
              Email address
            </label>
          </div>
          <div className="pxauth-control">
            <input
              id="pxauth-email"
              type="email"
              inputMode="email"
              autoComplete="email"
              autoFocus
              placeholder="Enter your email address"
              className={`pxauth-input${errors.email ? " is-invalid" : ""}`}
              aria-invalid={!!errors.email}
              aria-describedby={errors.email ? "pxauth-email-error" : undefined}
              {...register("email", { required: "This field is required" })}
            />
          </div>
          {errors.email && (
            <p className="pxauth-error" id="pxauth-email-error" role="alert">
              {errors.email.message as string}
            </p>
          )}
        </div>

        <button type="submit" className="pxauth-btn" disabled={loading}>
          {loading ? (
            <>
              <span className="pxauth-spinner" aria-hidden="true" />
              Sending&hellip;
            </>
          ) : (
            "Send reset link"
          )}
        </button>
      </form>
    </AuthShell>
  );
};

export default ResetPassword;
